// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import axios, { AxiosInstance, CreateAxiosDefaults } from 'axios';

import {
  applyAccessToken,
  applyLocalAccessToken,
} from './middlewares/applyAccessToken.js';
import { requestDataToSnakeCase } from './middlewares/requestDataToSnakeCase.js';
import { requestQueryParamsToSnakeCase } from './middlewares/requestQueryParamsToSnakeCase.js';
import { responseDataToCamelCase } from './middlewares/responseDataToCamelCase.js';
import { responseErrorInterceptor } from './middlewares/responseErrorInterceptor.js';

// Default paramsSerializer: serialize array query params as repeated keys
// (e.g. `?a=1&a=2`) instead of axios's default `[]` suffix (`?a[]=1&a[]=2`).
// Our backend expects the repeated-key form.
const defaultParamsSerializer = { indexes: null } as const;

const api = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  paramsSerializer: defaultParamsSerializer,
});

// This API client is used when should ignore addition token (workspace) in request
export const profileApi = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  paramsSerializer: defaultParamsSerializer,
});

// This API client is used by the `@mint-lib/auth` package.
export const guestApi = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  paramsSerializer: defaultParamsSerializer,
});

export function createApi(config?: CreateAxiosDefaults): AxiosInstance {
  return axios.create({
    paramsSerializer: defaultParamsSerializer,
    ...config,
  });
}

export default api;

api.interceptors.request.use(requestQueryParamsToSnakeCase, (error) =>
  Promise.reject(error instanceof Error ? error : new Error(String(error))),
);
api.interceptors.request.use(requestDataToSnakeCase, (error) =>
  Promise.reject(error instanceof Error ? error : new Error(String(error))),
);
api.interceptors.request.use(applyAccessToken, (error) =>
  Promise.reject(error instanceof Error ? error : new Error(String(error))),
);

api.interceptors.response.use(
  responseDataToCamelCase,
  responseErrorInterceptor,
);

guestApi.interceptors.request.use(requestQueryParamsToSnakeCase, (error) =>
  Promise.reject(error instanceof Error ? error : new Error(String(error))),
);
guestApi.interceptors.request.use(requestDataToSnakeCase, (error) =>
  Promise.reject(error instanceof Error ? error : new Error(String(error))),
);
guestApi.interceptors.response.use(
  responseDataToCamelCase,
  responseErrorInterceptor,
);

profileApi.interceptors.request.use(requestQueryParamsToSnakeCase, (error) =>
  Promise.reject(error instanceof Error ? error : new Error(String(error))),
);
profileApi.interceptors.request.use(requestDataToSnakeCase, (error) =>
  Promise.reject(error instanceof Error ? error : new Error(String(error))),
);
profileApi.interceptors.request.use(applyLocalAccessToken, (error) =>
  Promise.reject(error instanceof Error ? error : new Error(String(error))),
);

profileApi.interceptors.response.use(
  responseDataToCamelCase,
  responseErrorInterceptor,
);
